import React from "react";
import "./searchManager.scss";

const DropdownCreate = ({ options = [], onSelectOption, isOpen }) => {
  if (!isOpen || !options || options.length === 0) {
    return null;
  }

  return (
    <div className="dropdown-create-container">
      {options.map((option, index) => (
        <div
          key={index}
          className="dropdown-create-option"
          onClick={() => onSelectOption && onSelectOption(option)}
        >
          <span>{option}</span>
        </div>
      ))}
    </div>
  );
};

export default DropdownCreate;
